// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/requestcatalog/v1/requestcatalogbundles.proto" (package "c1.api.requestcatalog.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { RequestCatalogBundlesService } from "./requestcatalogbundles";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { RequestBundleResponse } from "./requestcatalogbundles";
import type { RequestBundleRequest } from "./requestcatalogbundles";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.requestcatalog.v1.RequestCatalogBundlesService
 */
export interface IRequestCatalogBundlesServiceClient {
    /**
     * @generated from protobuf rpc: RequestBundle(c1.api.requestcatalog.v1.RequestBundleRequest) returns (c1.api.requestcatalog.v1.RequestBundleResponse);
     */
    requestBundle(input: RequestBundleRequest, options?: RpcOptions): UnaryCall<RequestBundleRequest, RequestBundleResponse>;
}
/**
 * @generated from protobuf service c1.api.requestcatalog.v1.RequestCatalogBundlesService
 */
export class RequestCatalogBundlesServiceClient implements IRequestCatalogBundlesServiceClient, ServiceInfo {
    typeName = RequestCatalogBundlesService.typeName;
    methods = RequestCatalogBundlesService.methods;
    options = RequestCatalogBundlesService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: RequestBundle(c1.api.requestcatalog.v1.RequestBundleRequest) returns (c1.api.requestcatalog.v1.RequestBundleResponse);
     */
    requestBundle(input: RequestBundleRequest, options?: RpcOptions): UnaryCall<RequestBundleRequest, RequestBundleResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestBundleRequest, RequestBundleResponse>("unary", this._transport, method, opt, input);
    }
}
